import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { UserService } from './userService';
import { LocalStorage } from './localstorage.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public auth: UserService, public router: Router, private localStorage: LocalStorage) {}
  canActivate(): boolean {
    if (this.localStorage.getItem('isAuthenticated') !== 'true') {
      this.router.navigate(['login']);
      return false;
    }
    if (new Date(this.localStorage.getItem('tokenExpires')) < new Date()) {
      this.auth.clearUser();
      return false;
    }
    return true;
  }
}

@Injectable()
export class SignInService implements CanActivate {
  constructor(public auth: UserService, public router: Router, private localStorage: LocalStorage) {}
  canActivate(): boolean {
    if (this.localStorage.getItem('isAuthenticated') === 'true') {
      this.router.navigate(['home']);
      return false;
    }
    return true;
  }
}
